import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'dialog-content',
  template: `
    <div style="display: flex;justify-content: space-around;">
      <u-button label="Close" type="primary" (onClick)="this.dialogRef.close()"></u-button>
      <u-button label="Copy" type="primary" (onClick)="copy.emit()"></u-button>
    </div>
    <pre mat-dialog-content>
        {{ data.resource }}
      </pre
    >
  `,
})
export class ErrorItemDialog {
  constructor(public dialogRef: MatDialogRef<ErrorItemDialog>, @Inject(MAT_DIALOG_DATA) public data: { resource: string }) {}
  @Output() copy = new EventEmitter();
}
